/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-09-01 15:50:46
 * @LastEditors: geory
 * @LastEditTime: 2026-01-16 17:14:44
 */
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import config from "./config/config";

const Login = () => import("./components/Login");
const WLogin = () => import("./components/WLogin");
const Home = () => import("./components/Home");
const WHome = () => import("./components/WHome");
const ImageList = () => import("./components/ImageList");
const HuashuEdit = () => import("./components/HuashuEdit");
const HuashuImport = () => import("./components/HuashuImport");
const Download = () => import("./components/Download");
const Setting = () => import("./components/Setting");
const TestPC = () => import("./components/TestPC");
const AuthGuide = () => import("./components/AuthGuide");
const HuashuReview = () => import("./components/HuashuReview");
const AutoSend = () => import("./components/AutoSend");

const wminputWeb = [
  {
    path: "/autoSend",
    name: "autoSend",
    component: AutoSend,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/imageList",
    name: "imageList",
    component: ImageList,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/huashuEdit",
    name: "huashuEdit",
    component: HuashuEdit,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/huashuImport",
    name: "huashuImport",
    component: HuashuImport,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/",
    name: "download",
    component: Download,
  },
];

const wminputManager = [
  {
    path: "/huashuReview",
    name: "huashuReview",
    component: HuashuReview,
    meta: {
      keepAlive: false,
      hideTopBar: true,
    },
  },
  {
    path: "/wlogin",
    name: "wlogin",
    component: WLogin,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/whome",
    name: "whome",
    component: WHome,
    meta: {
      keepAlive: true,
    },
  },
];

const routerParams =
  config.app === "wminputWeb"
    ? {
        routes: wminputWeb,
        mode: "history",
        base: "/pc",
      }
    : {
        routes: wminputManager,
      };

const router = new VueRouter(routerParams);

//router.beforeEach()
export default router;
